import { useQuery } from 'react-query';
import getProduct from 'data/requests/getProduct';
import { Product } from 'model/product';

const useProduct = (brandId: string) => {
  const { data, isLoading, refetch } = useQuery<Product>(
    ['product', brandId],
    () => getProduct(brandId),
    {
      enabled: false,
    },
  );

  return { product: data, isLoading, refetch };
};

export default useProduct;
